import { cn } from '~/utils/cn';

import { Text } from '../../atoms/Text/view';

interface PropsStepper {
  total: number;
  current: number;
  labels?: string[];
  className?: string;
}

export default function Stepper({ total, current, labels, className }: PropsStepper) {
  return (
    <div className={cn('flex flex-col gap-quark w-full', className)}>
      <div className="flex items-center gap-quark">
        {Array.from({ length: total }).map((_, idx) => {
          const filled = idx <= current;
          return (
            <div
              key={idx}
              className={cn(
                'flex-1 h-[6px] rounded-full transition-colors',
                filled ? 'bg-intense-01' : 'bg-intense-01/20',
              )}
            />
          );
        })}
      </div>
      <div className="flex items-center justify-between">
        <Text className="text-captionMD color-intense-01">
          Etapa {current + 1} de {total}
        </Text>
        {labels?.[current] ? (
          <Text className="text-captionMD color-intense-01">{labels[current]}</Text>
        ) : null}
      </div>
    </div>
  );
}
